module.exports = __webpack_public_path__ + "static/media/Tubular Bells.b51c1d74.png";